import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { Route, Switch, withRouter, Redirect } from 'react-router-dom'
import { changeRoute } from '../../redux/Settings/actions'
import PrivateRoute from '../PrivateRoute'

import SignIn from '../../containers/SignIn'
import SignUp from '../../containers/SignUp'
import TermsAndConditions from '../../components/TermConditions/TermConditions'
import Users from '../../containers/Users'
import Channels from '../../containers/Channels'
import Messages from '../../containers/Messages'
import AppList from '../../containers/AppList'
import Dashboard from '../../containers/Dashboard'
import ProductNow from '../../containers/Products/Now'
import SettingsWebhook from '../../containers/Settings/Webhook'
import SettingsApplication from '../../containers/Settings/Application'
import SettingsSecurity from '../../containers/Settings/Security'
import SettingsAccount from '../../containers/Settings/Account'
import SettingsInstallation from '../../containers/Settings/Intallation'
import SettingsNotifications from '../../containers/Settings/Notifications'

import { LAYOUT_TYPE_FRAMED } from 'redux/Settings/constants'
import { changeLayoutType } from 'redux/Settings/actions'

class Routes extends React.Component {
    componentDidMount() {
        const { changeLayoutType } = this.props

        changeLayoutType(LAYOUT_TYPE_FRAMED)
        this.onRouteChanged()
    }

    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            this.onRouteChanged()
        }
    }

    onRouteChanged() {
        const { changeRoute } = this.props
        changeRoute(this.props.location.pathname)
    }

    render() {
        return (
            <Switch>
                <Route exact path="/signin" component={SignIn} />
                <Route exact path="/signup" component={SignUp} />
                <Route exact path="/terms" component={TermsAndConditions} />
                {/* <Route exact path="/register/now" component={OnboardingNow} /> */}
                <PrivateRoute path="/account" component={SettingsAccount} />
                <PrivateRoute path="/:app_id/dashboard" component={Dashboard} />
                <PrivateRoute path="/:app_id/users" component={Users} />
                <PrivateRoute path="/:app_id/channels" component={Channels} />
                <PrivateRoute path="/:app_id/messages" component={Messages} />
                <PrivateRoute path="/:app_id/settings/webhooks" component={SettingsWebhook} />
                <PrivateRoute path="/:app_id/settings/installation" component={SettingsInstallation} />
                <PrivateRoute path="/:app_id/settings/application" component={SettingsApplication} />
                <PrivateRoute path="/:app_id/settings/security" component={SettingsSecurity} />
                <PrivateRoute path="/:app_id/settings/notifications" component={SettingsNotifications} />
                <Redirect exact from='/:app_id/*' to='/:app_id/dashboard'/>
                <PrivateRoute path="/" component={AppList} />
            </Switch>
        )
    }
}

const mapActionsToProps = dispatch => ({
    changeRoute: bindActionCreators(changeRoute, dispatch),
    changeLayoutType: bindActionCreators(changeLayoutType, dispatch)
})

export default withRouter(
    connect(
        null,
        mapActionsToProps
    )(Routes)
)
